import React, { useState } from "react";
import HrLayout from "../../layouts/HrLayout";
import Card from "../../components/UI/Card";
import Button from "../../components/UI/Button";

export default function EmployeeProfile() {
  // Example employee data
  const [employee, setEmployee] = useState({
    name: "John Doe",
    email: "john.doe@example.com",
    department: "Development",
    role: "Frontend Developer",
    status: "Active",
    joiningDate: "2023-05-01",
    phone: "123-456-7890",
  });

  const [isEditing, setIsEditing] = useState(false);

  const handleChange = (e) => {
    setEmployee({ ...employee, [e.target.name]: e.target.value });
  };

  const handleSave = () => {
    console.log("Updated Employee Data:", employee);
    alert("Employee details updated!");
    setIsEditing(false);
  };

  return (
    <HrLayout>
      <div className="p-6 bg-gray-100 min-h-screen">
        <h1 className="text-3xl font-bold mb-6 text-gray-800">Employee Profile</h1>

        <Card>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <label className="block text-gray-700 font-semibold mb-1">Full Name</label>
              <input
                type="text"
                name="name"
                value={employee.name}
                disabled={!isEditing}
                onChange={handleChange}
                className={`w-full border p-2 rounded-md ${
                  isEditing ? "bg-white" : "bg-gray-200"
                }`}
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-1">Email</label>
              <input
                type="email"
                name="email"
                value={employee.email}
                disabled={!isEditing}
                onChange={handleChange}
                className={`w-full border p-2 rounded-md ${
                  isEditing ? "bg-white" : "bg-gray-200"
                }`}
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-1">Department</label>
              <input
                type="text"
                name="department"
                value={employee.department}
                disabled={!isEditing}
                onChange={handleChange}
                className={`w-full border p-2 rounded-md ${
                  isEditing ? "bg-white" : "bg-gray-200"
                }`}
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-1">Role</label>
              <input
                type="text"
                name="role"
                value={employee.role}
                disabled={!isEditing}
                onChange={handleChange}
                className={`w-full border p-2 rounded-md ${
                  isEditing ? "bg-white" : "bg-gray-200"
                }`}
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-1">Status</label>
              <select
                name="status"
                value={employee.status}
                disabled={!isEditing}
                onChange={handleChange}
                className={`w-full border p-2 rounded-md ${
                  isEditing ? "bg-white" : "bg-gray-200"
                }`}
              >
                <option value="Active">Active</option>
                <option value="On Leave">On Leave</option>
                <option value="Inactive">Inactive</option>
              </select>
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-1">Joining Date</label>
              <input
                type="date"
                name="joiningDate"
                value={employee.joiningDate}
                disabled={!isEditing}
                onChange={handleChange}
                className={`w-full border p-2 rounded-md ${
                  isEditing ? "bg-white" : "bg-gray-200"
                }`}
              />
            </div>

            <div>
              <label className="block text-gray-700 font-semibold mb-1">Phone</label>
              <input
                type="text"
                name="phone"
                value={employee.phone}
                disabled={!isEditing}
                onChange={handleChange}
                className={`w-full border p-2 rounded-md ${
                  isEditing ? "bg-white" : "bg-gray-200"
                }`}
              />
            </div>
          </div>

          <div className="mt-6">
            {isEditing ? (
              <Button
                className="bg-green-600 text-white px-6 py-2 rounded-md"
                onClick={handleSave}
              >
                Save Changes
              </Button>
            ) : (
              <Button
                className="bg-blue-600 text-white px-6 py-2 rounded-md"
                onClick={() => setIsEditing(true)}
              >
                Edit Profile
              </Button>
            )}
          </div>
        </Card>
      </div>
    </HrLayout>
  );
}
